var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u21B3 Icon Color",
    d: "M1.53 0.26C1.18 -0.09 0.61 -0.09 0.26 0.26C-0.09 0.61 -0.09 1.18 0.26 1.53L4.72 6L0.26 10.46C-0.09 10.81 -0.09 11.38 0.26 11.73C0.61 12.08 1.18 12.08 1.53 11.73L6 7.27L10.46 11.73C10.81 12.08 11.38 12.08 11.73 11.73C12.08 11.38 12.08 10.81 11.73 10.46L7.27 6L11.73 1.53C12.08 1.18 12.08 0.61 11.73 0.26C11.38 -0.09 10.81 -0.09 10.46 0.26L6 4.72L1.53 0.26Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancle);
export default __webpack_public_path__ + "static/media/cancle.0245c87779bba0288a725b95d45058cd.svg";
export { ForwardRef as ReactComponent };